import React from 'react'
import { WithCommon, ActionHeader } from '../Common'
import { ORDER_PATH, INCOME_PATH, PRIVILEGE_STORE_SERVICE_ID } from '@constant'
import { getAuthId } from '@util'

export default WithCommon(props => {
  const config = [
    {
      title: '订单管理',
      value: '1',
      route: 'orderManage_new',
      link: ORDER_PATH,
      back: '返回订单管理'
    }
  ]

  // 加盟店客服账号没有该菜单
  if (getAuthId() != PRIVILEGE_STORE_SERVICE_ID) {
    config.push({
      title: '收入管理',
      value: '2',
      route: 'incomeManage',
      link: INCOME_PATH,
      back: '返回收入管理'
    })
  }

  return <ActionHeader {...props} config={config} />
})
